var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.formType,{tag:"component",attrs:{"list-id":_vm.listId,"form-title":_vm.formTitle,"form-inputs":_vm.formInputs,"form-type":_vm.formType,"endpoint":_vm.endpoint,"show-wholesale-netsuite-form":_vm.showWholesaleNetsuiteForm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }